import { ExternalLink, Link2 } from 'react-feather';
import { LinkPreviewData, previewHost, providerLabel } from '../../../utils/social-links';
import './social-link-preview.css';

interface Props {
  preview: LinkPreviewData;
  className?: string;
}

export const SocialLinkPreview = ({ preview, className = '' }: Props) => {
  const provider = providerLabel(preview.provider);
  const title = preview.title || (preview.provider === 'link' ? previewHost(preview.url) : provider);
  const description = preview.description || preview.author_name || preview.url;

  return (
    <a
      href={preview.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`social-link-preview ${className}`.trim()}
      aria-label={`Abrir conteúdo do ${provider}`}
    >
      {preview.thumbnail_url ? (
        <img
          className="social-link-preview-thumbnail"
          src={preview.thumbnail_url}
          alt=""
          loading="lazy"
        />
      ) : (
        <div className="social-link-preview-thumbnail social-link-preview-placeholder" aria-hidden="true">
          <Link2 size={28} />
        </div>
      )}
      <div className="social-link-preview-content">
        <div className="social-link-preview-provider-row">
          <span className="social-link-preview-provider">{provider}</span>
          <ExternalLink size={14} aria-hidden="true" />
        </div>
        <strong className="social-link-preview-title">{title}</strong>
        <span className="social-link-preview-description">{description}</span>
      </div>
    </a>
  );
};
